import { authGuard, permissionGuard } from '@abp/ng.core';
import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./main/projects/projects/projects').then(c => c.ProjectsComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'project/:id',
    loadComponent: () => import('./main/project-details/project-details/project-details').then(c => c.ProjectDetailsComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'road/:id',
    loadComponent: () => import('./main/road-details/road-details/road-details').then(c => c.RoadDetailsComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'progress/new',
    loadComponent: () => import('./main/progress/progress/progress').then(c => c.ProgressComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: 'RoadsProjectManagement.Progress.Create'
    }
  },
  {
    path: 'progress/:originId',
    loadComponent: () => import('./main/progress/progress/progress').then(c => c.ProgressComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: 'RoadsProjectManagement.Progress'
    }
  },
  {
    path: 'certification/new',
    loadComponent: () => import('./main/certifications/certification/certification.component').then(c => c.CertificationComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: 'RoadsProjectManagement.Certifications.Create'
    }
  },
  {
    path: 'certification/:originId',
    loadComponent: () => import('./main/certifications/certification/certification.component').then(c => c.CertificationComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: 'RoadsProjectManagement.Certifications'
    }
  },
  {
    path: 'synchronization',
    loadComponent: () => import('./main/synchronization/synchronization').then(c => c.SynchronizationComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(c => c.DashboardComponent),
    canActivate: [],
  },
  {
    path: 'account',
    loadChildren: () => import('@volo/abp.ng.account/public').then(c => c.createRoutes()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(c => c.createRoutes()),
  },
  {
    path: 'language-management',
    loadChildren: () => import('@volo/abp.ng.language-management').then(c => c.createRoutes()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(c => c.createRoutes()),
  },
  {
    path: 'audit-logs',
    loadChildren: () => import('@volo/abp.ng.audit-logging').then(c => c.createRoutes()),
  },
  {
    path: 'openiddict',
    loadChildren: () => import('@volo/abp.ng.openiddictpro').then(c => c.createRoutes()),
  },
  {
    path: 'text-template-management',
    loadChildren: () => import('@volo/abp.ng.text-template-management').then(c => c.createRoutes()),
  },
  {
    path: 'setting-management',
    loadChildren: () => import('@abp/ng.setting-management').then(c => c.createRoutes()),
  },
];
